<template>
	<div style="white-space: pre-wrap; overflow-wrap: anywhere;"><template
		v-for="(trecho, i) in trechos"
	><a
		v-if="trecho.href"
		:key="`link-${i}`"
		:href="trecho.href"
		target="_blank"
		rel="noopener noreferrer nofollow"
	>{{ trecho.texto }}</a><span v-else :key="`texto-${i}`">{{ trecho.texto }}</span></template></div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { separarLinks } from '@/helpers/link-helpers'

const props = defineProps<{ texto?: string | null }>()

const trechos = computed(() => separarLinks(props.texto))
</script>
